import { SmartfireComponent } from "@smartfire/gutenberg-react";

export const __ = SmartfireComponent.__;

export function isEditing() {
  return window && window.wp && window.wp.editor;
}
